// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","messages":"_2i23","messagesArea":"_1IzI"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/MessageThread/MessageThread.scss
// module id = 9iNg
// module chunks = 0